import { AuthRoutes } from '@rx-applications/shared/auth/data-access';

export const layoutWithBannerRoutes: string[] = [
  AuthRoutes.InvalidUser,
  AuthRoutes.InvalidInvitation,
  AuthRoutes.ValidateInvitation,
];